import { Tab, Tabs } from "@mui/material";

interface AlertLanguageTabsProps {
    value: number;
    onChange: (value: number) => void;
}

function AlertLanguageTabs({ value, onChange }: AlertLanguageTabsProps) {
    return (
        <Tabs value={value} onChange={(_event, newValue) => onChange(newValue)} sx={{ mb: 1 }}>
            <Tab label="Norsk" />
            <Tab label="Engelsk" />
        </Tabs>
    );
}

export default AlertLanguageTabs;
